import { render } from "./productPackageDiscount.vue?vue&type=template&id=da1c962e&scoped=true"
import script from "./productPackageDiscount.vue?vue&type=script&lang=js"
export * from "./productPackageDiscount.vue?vue&type=script&lang=js"

import "./productPackageDiscount.vue?vue&type=style&index=0&id=da1c962e&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da1c962e"],['__file',"resources/js/vueComponents/admin/productPackageDiscount.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "da1c962e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('da1c962e', __exports__)) {
    api.reload('da1c962e', __exports__)
  }
  
  module.hot.accept("./productPackageDiscount.vue?vue&type=template&id=da1c962e&scoped=true", () => {
    api.rerender('da1c962e', render)
  })

}


export default __exports__